export const onEnterPress = onPress => ({ key }) => key === 'Enter' && onPress();



// WEBPACK FOOTER //
// ./src/lib/a11y.js